const imgDirective = {}
import {
    getSuffix,
    isPoster,
    getResizeParam,
    needProcess,
    getVideoProcesser,
    getImgProcesser,
    setSource
} from './utils'
imgDirective.install = (Vue, { errorImg }) => {
    Vue.directive('video', {
        inserted: setVideo,
        update: setVideo
    })
    Vue.directive('src', {
        inserted: setSrc,
        update: setSrc
    })
    async function setVideo(el, binding) {
        const src = binding.value
        if (src) {
            setSource(el, src)
        }
    }
    async function setSnapshot(el, src, param) {
        const processer = getVideoProcesser(el, param)
        setSource(el, src + processer)
    }
    function setImg(el, src, param) {
        const suffix = getSuffix(src)
        const processer = getImgProcesser(param, suffix)
        setSource(el, src + processer)
    }
    function setSrc(el, binding) {
        const src = binding.value
        detectError(el)
        const param = getResizeParam(el)
        if (src && param) {
            if (needProcess(src)) {
                if (isPoster(el)) {
                    setSnapshot(el, src, param)
                } else {
                    setImg(el, src, param)
                }
            } else {
                setSource(el, src)
            }
        } else {
            setSource(el, errorImg)
        }
    }
    function detectError(el) {
        if (errorImg && el.tagName !== 'VIDEO') {
            el.addEventListener('error', () => {
                setSource(el, errorImg)
            })
        }
    }
}
export { imgDirective }
